import React from 'react';
import { enquireScreen } from 'enquire-js';

import Banner5 from './Banner5';
import Content13 from './Content13';
import Feature4 from './Feature4';
import Feature2 from './Feature2';
import Feature3 from './Feature3';
import Teams0 from './Teams0';
import Content12 from './Content12';

import {
  Banner50DataSource,
  Content130DataSource,
  Feature40DataSource,
  Feature20DataSource,
  Feature30DataSource,
  Content131DataSource,
  Teams00DataSource,
  Content120DataSource,
} from './data.source';

import './less/antMotionStyle.less';

let isMobile;
enquireScreen(b => {
  isMobile = b;
});
export default class Home extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isMobile,
      direction: "rtl"
    };
  }

  async componentDidMount() {
    window.scroll(0,0);
  }

  render() {
    return (
      <div>
        <Banner5
          id="Banner5_0"
          key="Banner5_0"
          dir={this.state.direction}
          dataSource={Banner50DataSource}
          isMobile={this.state.isMobile}
        />
      <Content13
          id="Content13_0"
          key="Content13_0"
          dir={this.state.direction}
          dataSource={Content130DataSource}
          isMobile={this.state.isMobile}
        />
      <Feature4
          id="Feature4_0"
          key="Feature4_0"
          dir={this.state.direction}
          dataSource={Feature40DataSource}
          isMobile={this.state.isMobile}
        />
      <Feature2
          id="Feature2_0"
          key="Feature2_0"
          dir={this.state.direction}
          dataSource={Feature20DataSource}
          isMobile={this.state.isMobile}
        />
      <Feature3
          id="Feature3_0"
          key="Feature3_0"
          dir={this.state.direction}
          dataSource={Feature30DataSource}
          isMobile={this.state.isMobile}
        />
      <Content13
          id="Content13_1"
          key="Content13_1"
          dataSource={Content131DataSource}
          isMobile={this.state.isMobile}
        />
      <Teams0
          id="Teams0_0"
          dir={this.state.direction}
          key="Teams0_0"
          dataSource={Teams00DataSource}
          isMobile={this.state.isMobile}
        />
      <Content12
          id="Content12_0"
          key="Content12_0"
          dir={this.state.direction}
          dataSource={Content120DataSource}
          isMobile={this.state.isMobile}
        />
      </div>
    );
  }
}
